import { lazy } from 'react';

// project-imports
import DashboardLayout from 'layout/Dashboard';
import Loadable from 'components/Loadable';
import AuthGuard from '../layout/Auth/AuthGuard';
import PermissionGuard from '../views/components/PermissionGuard';
import { PERMISSIONS } from '../permissions/permissions';
import { ViewLocation } from '../views/location/view-location/ViewLocation';
const LocationDetails = Loadable(lazy(() => import('../sections/location/location-details/LocationDetails')));
const Locations = Loadable(lazy(() => import('../sections/location/Locations/Locations')));
const EditLocation = Loadable(lazy(() => import('../sections/location/edit-location/EditLocation')));
const Location = Loadable(lazy(() => import('../views/location/add-location/Location')));

// ==============================|| FORMS ROUTING ||============================== //

const LocationRoutes = {
  path: '/',
  element: <DashboardLayout />, // Keep this outside so it's always visible
  children: [
    {
      path: 'location',
      // Wrap ONLY the protected content
      element: <AuthGuard allowedRoles={['SUPER_ADMIN', 'ADMIN']} />,
      children: [
        {
          index: true,
          element: (
            <PermissionGuard permission={PERMISSIONS.LOCATION.CREATE}>
              <Locations />
            </PermissionGuard>
          )
        },
        {
          path: 'add-location',
          element: (
            <PermissionGuard permission={PERMISSIONS.LOCATION.CREATE}>
              <Location />
            </PermissionGuard>
          )
        },
        {
          path: 'view-location/:id',
          element: <LocationDetails />,
          meta: {
            breadcrumb: 'Location Details',
            parent: 'location'
          }
        },
        {
          path: ':id/edit-location',
          element: (
            <PermissionGuard permission={PERMISSIONS.LOCATION.UPDATE}>
              <EditLocation />
            </PermissionGuard>
          ),
          meta: {
            breadcrumb: 'Edit Location',
            parent: 'location'
          }
        },
        {
          path: 'current-location',
          element: (
            <PermissionGuard permission={PERMISSIONS.LOCATION.UPDATE}>
              <ViewLocation/>
            </PermissionGuard>
          ),
          meta: {
            breadcrumb: 'Current Location',
            parent: 'location'
          }
        }
      ]
    }
  ]
};

export default LocationRoutes;
